import React from 'react'
import LivenessWebcam from '@components/LivenessWebcam'

const FaceReconignaztion: React.FC = () => {

    return(

        <>
            <LivenessWebcam />
        </>

    )

}

export default FaceReconignaztion